module.exports = __webpack_public_path__ + "img/column_multi.0f82819d.svg";